const css = `._columns_fcvr2_1 {
  display: grid;
  grid-template-rows: auto;
}
._columns_fcvr2_1[data-direction=rtl] {
  direction: rtl;
}
._columns_fcvr2_1[data-number-of-columns="1"] {
  grid-template-columns: repeat(1, 1fr);
}
._columns_fcvr2_1[data-number-of-columns="2"] {
  grid-template-columns: repeat(2, 1fr);
}
._columns_fcvr2_1[data-number-of-columns="3"] {
  grid-template-columns: repeat(3, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="3"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="3"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="4"] {
  grid-template-columns: repeat(4, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="4"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="4"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="5"] {
  grid-template-columns: repeat(5, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="5"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="5"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="6"] {
  grid-template-columns: repeat(6, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="6"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="6"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="7"] {
  grid-template-columns: repeat(7, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="7"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="7"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="8"] {
  grid-template-columns: repeat(8, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="8"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="8"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="9"] {
  grid-template-columns: repeat(9, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="9"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="9"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-number-of-columns="10"] {
  grid-template-columns: repeat(10, 1fr);
}
@media (min-width: 768px) and (max-width: 991px) {
  ._columns_fcvr2_1[data-number-of-columns="10"][data-is-responsive=true] {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  ._columns_fcvr2_1[data-number-of-columns="10"][data-is-responsive=true] {
    direction: ltr;
    grid-template-columns: repeat(1, 1fr);
  }
}
._columns_fcvr2_1[data-gap=xs] {
  gap: 2px;
}
._columns_fcvr2_1[data-gap=sm] {
  gap: 4px;
}
._columns_fcvr2_1[data-gap=md] {
  gap: 8px;
}
._columns_fcvr2_1[data-gap=lg] {
  gap: 16px;
}
._columns_fcvr2_1[data-gap=xl] {
  gap: 24px;
}
._columns_fcvr2_1[data-vertical-alignment=top] {
  align-items: start;
}
._columns_fcvr2_1[data-vertical-alignment=center] {
  align-items: center;
}
._columns_fcvr2_1[data-vertical-alignment=bottom] {
  align-items: end;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "columns": "_columns_fcvr2_1"
};